import { combineReducers } from "redux";
import webReducer from "./webReducer";
import partnerReducer from "./partnerReducer";
import commonReducer from "./commonReducer";
import staticpageReducer from "./staticpageReducer";

const rootReducer = combineReducers({
    partnerReducer,
    webReducer,
    commonReducer,
    staticpageReducer
});

export default rootReducer;